module.exports = __webpack_public_path__ + "static/img/lato-v23-latin-ext_latin-900.7dfa126.svg";